import React from 'react'
import {Component} from 'react'
import './community-info.scss'

export default class extends Component {
  theProviders( propName ){
    if( this.props.event[propName] ){
      return this.props.event[propName].map( function( provider, i ){
        return <Provider key={i} provider={ provider }/>
      })
    }	else {
      return null
    }
  }
  render(){
    let event = this.props.event ? this.props.event : {}
    if(
      event.communityActivations &&
      ( event.communityActivations.length || event.entertainments.length )
    ){
      return (
        <section className={`${this.props.className} community-info`}>
          { this.theProviders( 'communityActivations' ) }
          { this.theProviders( 'entertainments' ) }
        </section>
      )
    }
    return null
  }
}

class Provider extends Component {
  render(){
    return (
      <div className="community-info__provider">
        <span className="community-info__tag">{this.props.provider.types[0]}</span>
        <div className="row">
          <div className="col-md-3 col-xs-12">
            { this.props.provider.logoUrl &&
              <img className="community-info-img-desktop" src={this.props.provider.logoUrl} />
            }
          </div>
          <div className="col-md-9 col-xs-12">
            <h4>{this.props.provider.name}</h4>
            <Linkify tagName="p" className="community-info__about">{ this.props.provider.about }</Linkify>
            <div>
            { this.props.provider.logoUrl &&
              <img className="community-info-img-mobile" src={this.props.provider.logoUrl} />
            }
            </div>
          </div>
        </div>
      </div>
    )
  }
}
